// import ToggleClub from "../ToggleClub/ToggleClub";

import { SessionExtra } from "../../store/Session/SessionModel";

import DataTargetTable from "../DataTargetTable/DataTargetTable";
import TargetModuleKeyData from "../TargetModuleKeyData/TargetModuleKeyData";
import "./style.css";

interface Props {
  tabSelected: "ball-data" | "club-data" | "key-data";
  sessionData: SessionExtra;
}

const TargetTables = ({ tabSelected, sessionData }: Props): JSX.Element => {
  return (
    <div className="club-tables">
      {sessionData.targets.map((target, index) => {
        return (
          <div key={index}>
            <div className="table-header">
              <TargetModuleKeyData target={target} tabSelected={tabSelected} measuringSystem={sessionData.measuringSystem} />
            </div>
            {target.isShowShots && (
              <DataTargetTable
                dataTableType="key-data"
                tabSelected={tabSelected}
                target={target}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TargetTables;
